<template>
    <v-row>
        <v-col cols="4">
            <v-autocomplete
                v-if="experimentRelationshipConfig.allowMultiple"
                :items="registryEntries"
                :multiple="true"
                :label="experimentRelationshipConfig.registrySchema.displayName"
                :clearable="!experimentRelationshipConfig.required"
                :rules="getValidationRules()"
                v-model="selectedRelationshipRegistryEntries"
                item-title="displayName"
                @update:model-value="onChanged"
                return-object
            />
            <v-autocomplete
                v-if="!experimentRelationshipConfig.allowMultiple"
                :items="registryEntries"
                :label="experimentRelationshipConfig.registrySchema.displayName"
                :clearable="!experimentRelationshipConfig.required"
                v-model="selectedRelationshipRegistryEntry"
                item-title="displayName"
                @update:model-value="onChanged"
                return-object
            />
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
import { withLoadingScreen } from "@/lib/loading";
import {
    ExperimentRelationshipsForSetupDTO,
    RelationshipConfigForExperimentSetup,
} from "@/services/experimentRelationships/models";
import { RegistryEntry } from "@/services/registries/registriesAPI";
import { ref } from "vue";
import _ from "lodash";
import { requiredArrayValueRule } from "@/lib/validationUtils";

const { experimentRelationshipConfig } = defineProps<{
    experimentRelationshipConfig: RelationshipConfigForExperimentSetup;
}>();

const registryEntries = ref<RegistryEntry[]>([]);
const selectedRelationshipRegistryEntries =  ref<RegistryEntry[]>([]);
const selectedRelationshipRegistryEntry = ref<RegistryEntry>();

const emit = defineEmits<{
    (e: "onChanged", experimentRelationshipForSetupDTO: ExperimentRelationshipsForSetupDTO): void;
}>();

async function fetchRegistryEntries() {
    await withLoadingScreen(async () => {
        const registrySchema = experimentRelationshipConfig.registrySchema;
        registryEntries.value = registrySchema.registryEntries;
        if (experimentRelationshipConfig.defaultRegistryEntries) {
            if (experimentRelationshipConfig.allowMultiple) {
                selectedRelationshipRegistryEntries.value = experimentRelationshipConfig.defaultRegistryEntries;
            } else {
                selectedRelationshipRegistryEntry.value = experimentRelationshipConfig.defaultRegistryEntries[0];
            }
            onChanged();
        }
    });
}

function getValidationRules() {
    if (experimentRelationshipConfig.required) {
        return [requiredArrayValueRule(experimentRelationshipConfig.registrySchema.displayName)];
    } else {
        return [];
    }
}

function onChanged() {
    let selections: RegistryEntry[];
    if (!_.isNil(selectedRelationshipRegistryEntry.value)) {
        selections = [
            selectedRelationshipRegistryEntry.value
        ];
    } else {
        selections = [
            ...selectedRelationshipRegistryEntries.value
        ];
    }
    const experimentRelationshipForSetupDTO = {
        type: experimentRelationshipConfig.type,
        registrySchemaId: experimentRelationshipConfig.registrySchemaId,
        registryEntryIds: selections.map((selection) => selection.id),
    }
    emit("onChanged", experimentRelationshipForSetupDTO);
}

//TODO: add emits, emitting either entries or entry depending on whether multiple are allowed. Catch
//emit to experimentrelationshipsetupform, build map of selected registry entries there to then pass
//as to experiment setup v2 form, so it's included as a part of the experiment setup config sent to
//backend so we can handling the saving of experiment relationship(s)

fetchRegistryEntries();
</script>
